import { useSuspenseQuery } from "@apollo/client";

import { WASTE_LINES_UNIFIED_COUNT_QUERY } from "../../ManifestLineItems/api";
import { useFacilityWasteLineItemsDefaultSearch } from "./useFacilityWasteLineItemsDefaultSearch";

export function useHasWasteShipmentData() {
  const search = useFacilityWasteLineItemsDefaultSearch();
  const { data } = useSuspenseQuery(WASTE_LINES_UNIFIED_COUNT_QUERY, {
    variables: { search },
  });
  return (data?.wasteLinesUnified?.count ?? 0) > 0;
}
